import { format, parseISO } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { RECENT_BILLS_STATUSES } from '_constants/billing';
import { theme } from '_constants/theme';
import { formatPrice } from '_helpers/common';

import Indicator from 'components/shared/Indicator';
import Paginate from 'components/shared/Paginate';
import Table from 'components/shared/Table';
import Text from 'components/shared/layouts/Text';

const StyledContainer = styled.div`
  .paginate-container {
    padding-top: ${theme.spaces.large}px;
  }
`;

const StyledLinkContainer = styled.div`
  a {
    font-family: 'RethinkSans';
    font-size: ${theme.fontSizes.regular}px;
    font-weight: 400;
    line-height: 16px;
    color: ${theme.colors.deepBlueGreen};

    &:hover {
      color: ${theme.colors.cyanBlue};
    }
  }
`;

const getColumns = () => {
  const columns = [
    {
      dataIndex: 'crmOrderId',
      title: 'ORDER ID',
      width: '14%',
      render: (row) => (
        <StyledLinkContainer>
          <Link to={`../order/${row?.orderId}`}>{row?.crmOrderId}</Link>
        </StyledLinkContainer>
      ),
    },
    {
      dataIndex: 'paymentStatusIndicator',
      title: null,
      width: '2%',
      minWidth: '16px',
      render: (row) => <Indicator status={row?.mainPaymentStatus} />,
    },
    {
      dataIndex: 'paymentStatusValue',
      title: 'PAYMENT STATUS',
      width: '18%',
      render: (row) => <Text>{RECENT_BILLS_STATUSES[row?.mainPaymentStatus] || row?.mainPaymentStatus}</Text>,
    },
    {
      dataIndex: 'paymentDate',
      title: 'PAYMENT DATE',
      width: '18%',
      render: (row) => (
        <Text>
          {row?.mainPaymentDate && !row?.mainPaymentDate?.includes('null')
            ? format(parseISO(row.mainPaymentDate), 'MMMM dd, yyyy')
            : '-'}
        </Text>
      ),
    },
    {
      dataIndex: 'totalPrice',
      title: 'PRICE',
      width: '12%',
      right: true,
      render: (row) => <Text>{formatPrice(row?.totalPrice)}</Text>,
    },
    {
      dataIndex: 'totalRefunded',
      title: 'REFUNDED',
      width: '12%',
      right: true,
      render: (row) => <Text>{formatPrice(row?.totalRefunded)}</Text>,
    },
    {
      dataIndex: 'totalChargeback',
      title: 'CHARGEBACK',
      width: '12%',
      right: true,
      render: (row) => <Text>{formatPrice(row?.totalChargeback)}</Text>,
    },
    {
      dataIndex: 'totalAmount',
      title: 'TOTAL AMOUNT',
      width: '12%',
      right: true,
      render: (row) => <Text>{formatPrice(row?.totalAmount)}</Text>,
    },
  ];

  return columns;
};

const BillsTable = ({ skeletonRowsNum, loading, items, pageCount, currentPage, onPageChange }) => {
  return (
    <StyledContainer>
      <Table columns={getColumns()} rows={items} loading={loading} skeletonRowsNum={skeletonRowsNum} />
      {!loading && !items?.length && <Text centered>No billing history found</Text>}
      <div className="paginate-container">
        <Paginate pageRangeDisplayed={3} pageCount={pageCount} currentPage={currentPage} onPageChange={onPageChange} />
      </div>
    </StyledContainer>
  );
};

BillsTable.propTypes = {
  skeletonRowsNum: PropTypes.bool,
  loading: PropTypes.bool,
  items: PropTypes.array,
  pageCount: PropTypes.number,
  currentPage: PropTypes.number,
  onPageChange: PropTypes.func,
};

export default BillsTable;
